import type { FamilyAgendaGroup, FamilyAgendaItem } from './types';
import { addDays, format, isWithinInterval, parseISO, startOfDay } from 'date-fns';

export const FAMILY_AGENDA_LOOKAHEAD_DAYS = 10;

/** Return events across all kids from today through the next 10th calendar day. */
export function getUpcomingFamilyAgendaItems(
  items: FamilyAgendaItem[],
  today: Date,
): FamilyAgendaItem[] {
  const startDate = startOfDay(today);
  const endDate = addDays(startDate, FAMILY_AGENDA_LOOKAHEAD_DAYS);

  return items
    .filter(item =>
      isWithinInterval(parseISO(item.date), {
        start: startDate,
        end: endDate,
      }),
    )
    .sort((firstItem, secondItem) => firstItem.date.localeCompare(secondItem.date));
}

/** Group agenda items by calendar date, preserving first-seen order. */
export function groupFamilyAgendaByDate(items: FamilyAgendaItem[]): FamilyAgendaGroup[] {
  return items.reduce<FamilyAgendaGroup[]>((groups, item) => {
    const existing = groups.find(group => group.key === item.date);

    if (existing) {
      existing.items.push(item);
      return groups;
    }

    groups.push({
      key: item.date,
      label: format(parseISO(item.date), 'EEEE, MMM d'),
      items: [item],
    });
    return groups;
  }, []);
}
